// copy this file into config.js and set the right settings

// url of the server
const serverUrl = "https://api.dev.freedrumrocks.net";

export default serverUrl;
